import { injectable } from "inversify";

@injectable()
export class StorageService {
  private items: { [key: string]: string } = {};
  isLocalstorageEnabled(): boolean {
    try {
      localStorage.setItem("test", "test");
      localStorage.removeItem("test");
      return true;
    } catch (e) {
      return false;
    }
  }
  setItem(key: string, value: string): void {
    if (this.isLocalstorageEnabled()) {
      localStorage.setItem(key, value);
    } else {
      this.items[key] = value;
    }
  }

  getItem(key: string): string | null {
    if (this.isLocalstorageEnabled()) {
      return localStorage.getItem(key);
    } else {
      return this.items[key] ?? null;
    }
  }

  removeItem(key: string): void {
    if (this.isLocalstorageEnabled()) {
      localStorage.removeItem(key);
    } else {
      delete this.items[key];
    }
  }
}
